import Configuration from "../shared/configuration";
import EndPointEntity from "../shared/endpointentity";
import API from "../shared/API";
import Common from "./common";

// Task Board (Audit -> Task Board) — reads the read-only Admin_GetTaskBoard proc on db37, which
// returns today's (or a given date's) pickup + delivery tasks per store in four states
// (done/open/overdue/cancelled) + network totals + a 7-day trend, as one JSON object.
export default class TaskBoardService {
  constructor() {
    this.config = new Configuration();
    this.endpoint = new EndPointEntity();
    this.common = new Common();
  }

  // date = "YYYY-MM-DD" (empty = today).
  async getBoard(date, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.GET_TASK_BOARD });
    let out = {};
    await api.endpoints[this.endpoint.GET_TASK_BOARD]
      .getAllPost({ Date: date || "" })
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });

    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        out = await this.getBoard(date, true);
        return out;
      } catch (e) {
        return { statusCode: 401, message: "Session expired - please log in again." };
      }
    }
    // WebAPI returns the board as a JSON string in Data; parse it here.
    if (out && typeof out.data === "string") {
      try { return JSON.parse(out.data); } catch (e) { return { error: "Could not parse Task Board response." }; }
    }
    return out && out.data !== undefined ? out.data : out;
  }

  // Save the trip-planner tunables (service mins, gap, radius, capacity, shift).
  async saveConfig(cfg, isRetry) {
    const api = new API({ url: this.config.ITEM_STORE_URL });
    api.createEntity({ name: this.endpoint.SAVE_TRIP_CONFIG });
    let out = {};
    await api.endpoints[this.endpoint.SAVE_TRIP_CONFIG]
      .getAllPost(cfg)
      .then((response) => { out = response.data; })
      .catch((err) => { out = this.common.handleError(err); });
    if (out && out.statusCode === 401 && !isRetry) {
      try {
        const response = await this.common.refreshToken();
        this.common.setToken(response);
        return await this.saveConfig(cfg, true);
      } catch (e) { return { statusCode: 401, message: "Session expired - please log in again." }; }
    }
    return out;
  }
}
